import React, { ComponentType } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { SettingsScreen, FaqScreen, MyPathwayScreen, TestScreen, TeleassistanceRequestScreen, MyDevicesScreen } from './UserScreens';
import PersonalData from '../screens/PersonalData';
import EmergencyContact from '../screens/EmergencyContact';
import { TUserStackParamList } from '../types';

type ScreenConfig = { name: keyof TUserStackParamList; component: ComponentType<any>; options: object };

const Stack = createNativeStackNavigator<TUserStackParamList>();

const USER_SCREENS: ScreenConfig[] = [
  { name: 'Settings' as const, component: SettingsScreen, options: { headerShown: false } },
  { name: 'PersonalData' as const, component: PersonalData, options: { headerShown: false } },
  { name: 'EmergencyContacts' as const, component: EmergencyContact, options: { headerShown: false } },
  { name: 'PathDetails' as const, component: SettingsScreen, options: { headerShown: false } },
  { name: 'MyPathway' as const, component: MyPathwayScreen, options: { headerShown: false } },
  { name: 'FAQ' as const, component: FaqScreen, options: { headerShown: false } },
  { name: 'TeleassistanceRequest' as const, component: TeleassistanceRequestScreen, options: { headerShown: false } },
  { name: 'MyDevices' as const, component: MyDevicesScreen, options: { headerShown: false } },
  { name: 'DevPlayground' as const, component: TestScreen, options: { headerShown: false } },
];

export const USER_SCREEN_NAMES: string[] = USER_SCREENS.map(s => s.name);

export default function UserNavigator() {
  return (
    <Stack.Navigator>
      {USER_SCREENS.map((screen) => (
        <Stack.Screen
          key={screen.name}
          name={screen.name}
          component={screen.component}
          options={screen.options}
        />
      ))}
    </Stack.Navigator>
  );
}
